// extracted by mini-css-extract-plugin
module.exports = {"ant-upload-drag-container":"styles_ant-upload-drag-container__2Yb_O"};